var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"apps"}},[_c('div',{staticClass:"text"},[_c('div',[_vm._v("敬 请 期 待!")]),_c('div',{staticClass:"small"},[_vm._v("需要使用该应用，请联系客服(17380566578)")])])])
}]

export { render, staticRenderFns }